import React from 'react';
import { IconProps } from './types';

const EnachIcon: React.FC<IconProps> = props => {
  const { fillColor = 'var(--bg-primary)', width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.18611 3.18414H2.77058C2.65016 3.18414 2.5498 3.2845 2.5498 3.40492V20.8162C2.5498 20.9366 2.65016 21.0369 2.77058 21.0369H15.395C15.5154 21.0369 15.6158 20.9366 15.6158 20.8162V3.41496C15.6158 3.29453 15.5154 3.19418 15.395 3.19418H7.18611V3.18414Z"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M16.5991 21.9C19.2986 21.9 21.4863 19.7123 21.4863 17.0128C21.4863 14.3133 19.2986 12.1256 16.5991 12.1256C13.8996 12.1256 11.7119 14.3133 11.7119 17.0128C11.7119 19.7123 13.8996 21.9 16.5991 21.9Z"
        fill="#001833"
        stroke={fillColor}
        strokeWidth="1.2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.9131 17.1031L16.6793 15.3268L18.4555 17.1031"
        stroke={fillColor}
        strokeWidth="0.9"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M16.6794 15.3268V19.1804"
        stroke={fillColor}
        strokeWidth="0.9"
        strokeLinejoin="round"
      />
      <path d="M5.04999 8.89423H13.05" stroke="#FCFCFD" strokeMiterlimit="10" />
      <path d="M5.04999 11.7325H10.55" stroke="#FCFCFD" strokeMiterlimit="10" />
      <path
        d="M11.8928 3.08381H10.5481C10.3675 2.46162 9.79544 2 9.11304 2C8.43064 2 7.85863 2.46162 7.678 3.08381H6.33326C6.21284 3.08381 6.11249 3.18417 6.11249 3.30459V3.85653C6.11249 4.70953 6.80492 5.40197 7.65792 5.40197H10.5581C11.4111 5.40197 12.1036 4.70953 12.1036 3.85653V3.30459C12.1036 3.18417 12.0032 3.08381 11.8828 3.08381H11.8928Z"
        fill="#001833"
        stroke={fillColor}
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default EnachIcon;
